export default __webpack_public_path__ + "static/media/EN.583699d9.svg";